import { Typography } from '../Typography/Typography.js';
import { getSectionStyles, getSectionTitleStyles } from './SectionStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const Section = _ref => {
  let {
    title,
    children,
    ...rest
  } = _ref;
  return jsxs("section", {
    css: getSectionStyles,
    ...rest,
    children: [title && jsx(Typography, {
      css: getSectionTitleStyles,
      component: "h6",
      variant: "subtitle2",
      children: title
    }), children]
  });
};

export { Section };
//# sourceMappingURL=Section.js.map
